import { render, staticRenderFns } from "./Customers1.vue?vue&type=template&id=5521a502&"
import script from "./Customers1.vue?vue&type=script&lang=js&"
export * from "./Customers1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports